export var ProductVariationType;
(function (ProductVariationType) {
    ProductVariationType["CUSTOM"] = "CUSTOM";
    ProductVariationType["SIZE"] = "SIZE";
    ProductVariationType["COLOR"] = "COLOR";
    ProductVariationType["LANGUAGE"] = "LANGUAGE";
})(ProductVariationType || (ProductVariationType = {}));
